import useAuth from "./useAuth";
import { refreshAccessToken } from "../../utils/authRefresh";

const useRefreshToken = () => {
  const { setAuth } = useAuth();

  const refresh = async () => {
    const newAccessToken = await refreshAccessToken();
    setAuth((prev) => ({ ...prev, accessToken: newAccessToken }));
    return newAccessToken;
  };

  return refresh;
};

export default useRefreshToken;
